import React, { FC, useMemo } from 'react';
import { FeedbackIndicatorWrapper } from './Atoms';
import { useStudentFeedbackForTrajectory, useTeacherFeedback } from '../hooks';
import { Feedback } from '../../../config/api/models/Feedback';
import { useUser } from '../../shared';
import { BlockType } from '../../../config/api/models/Block';
import { useTheme } from '@material-ui/core';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type FeedbackIndicatorProps = {
  pageId: string;
  blockId?: string;
  blockType?: BlockType;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  hasFeedback?: boolean;
};

export const FeedbackIndicator: FC<FeedbackIndicatorProps> = ({
  pageId,
  blockId,
  blockType,
  onClick,
  className,
  hasFeedback: hasFeedbackProp,
}) => {
  const { isStudent, isTeacher } = useUser();
  const theme = useTheme();
  const { feedback: teacherFeedback } = useTeacherFeedback();
  const { feedback: studentFeedback } = useStudentFeedbackForTrajectory();

  const relevantTeacherFeedback: Feedback[] | undefined = useMemo(() => {
    if (teacherFeedback != null && teacherFeedback.find((item) => item.pageId === pageId)) {
      return !!!blockId
        ? teacherFeedback.find((item) => item.pageId === pageId)?.trajectorFeedbacks
        : teacherFeedback
            .find((item) => item.pageId === pageId)
            ?.blockFeedbacks?.find((item) => item.blockId === blockId)?.feedbacks;
    }
  }, [teacherFeedback, pageId, blockId]);

  const relevantStudentFeedback: Feedback[] | undefined = useMemo(() => {
    if (studentFeedback != null && studentFeedback.some((item) => item.pageId === pageId)) {
      return !!!blockId
        ? studentFeedback.find((item) => item.pageId === pageId)?.feedback?.trajectoryFeedbacks
        : studentFeedback
            .find((item) => item.pageId === pageId)
            ?.feedback?.blockFeedbacks.filter((item) => item.blockId === blockId);
    }
  }, [studentFeedback, pageId, blockId]);

  const hasFeedback = !(
    (relevantTeacherFeedback == null || relevantTeacherFeedback.length === 0) &&
    (relevantStudentFeedback == null || relevantStudentFeedback.length === 0)
  );

  return isTeacher || (isStudent && hasFeedback) ? (
    <FeedbackIndicatorWrapper blockType={blockType} hasFeedback={hasFeedback} className={className}>
      <FontAwesomeSpriteButton
        buttonStyle={{ marginTop: 0 }}
        icon={SpriteIconsLight.FEEDBACK_TEXT}
        color={hasFeedbackProp ? theme.palette.common.white : theme.palette.grey.A100}
        iconSize="md"
        onClick={onClick}
      />
    </FeedbackIndicatorWrapper>
  ) : null;
};
